import { StyleSheet } from 'react-native';
import { COLORS } from '@/constants/colors';
import {
  SCREEN_WIDTH,
  HERO_HEIGHT,
  CARD_BORDER_RADIUS,
  CARD_MARGIN_TOP,
  CARD_PADDING,
  PHOTO_BORDER_RADIUS,
  LOCKED_PHOTO_HEIGHT,
} from './constants';

export const getStyles = (isDark: boolean) => StyleSheet.create({
  scrollView: {
    flex: 1,
    backgroundColor: isDark ? COLORS.BLACK : COLORS.LIGHT_BACKGROUND,
  },
  scrollContent: {
    flexGrow: 1,
    padding: 24,
  },
  container: {
    flex: 1,
    backgroundColor: isDark ? COLORS.BLACK : COLORS.LIGHT_BACKGROUND,
  },
  heroImage: {
    width: SCREEN_WIDTH,
    height: HERO_HEIGHT,
    backgroundColor: isDark ? COLORS.ZINC_900 : COLORS.ZINC_200,
  },
  heroImageFull: {
    width: '100%',
    height: '100%',
  },
  contentCard: {
    backgroundColor: isDark ? COLORS.ZINC_900 : COLORS.WHITE,
    borderTopLeftRadius: CARD_BORDER_RADIUS,
    borderTopRightRadius: CARD_BORDER_RADIUS,
    marginTop: CARD_MARGIN_TOP,
    padding: CARD_PADDING,
    flex: 1,
    paddingTop: 20,
  },
  lockedPhotoContainer: {
    position: 'relative',
    borderRadius: PHOTO_BORDER_RADIUS,
    overflow: 'hidden',
    backgroundColor: isDark ? COLORS.ZINC_900 : COLORS.ZINC_200,
  },
  lockedPhotoImage: {
    width: '100%',
    height: LOCKED_PHOTO_HEIGHT,
    opacity: 0.3,
  },
  lockedPhotoOverlay: {
    position: 'absolute',
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    backgroundColor: isDark ? 'rgba(0, 0, 0, 0.7)' : COLORS.WHITE_90,
    alignItems: 'center',
    justifyContent: 'center',
  },
});

